import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { apiGetModel } from '../../../useApiHook';
import { callAxios } from '../../../../services/callAPIMiddleware';

export const useFetchConfigureAssistedPlanner = forceReload => {
  const auth = useSelector(state => state.global.auth);
  const jwtToken = auth.jwtToken;
  const [state, setState] = useState({ response: null, refresh: forceReload });
  const [error, setError] = useState(null);

  const getModel = apiGetModel('GetConfigureAssistedPlanner', {}, forceReload);
  const setRequestResponse = response => {
    setState({ ...state, response, refresh: forceReload });
  };

  useEffect(() => {
    if (jwtToken) {
      callAxios(auth, getModel.url, getModel.method, getModel.data)
        .then(result => setRequestResponse(result.data))
        .catch(ex => {
          setError(ex.mesage);
          setState({ ...state });
        });
    }
  }, [jwtToken, getModel.url, getModel.reloadData]);

  return {
    data: state.response != null ? state.response : {},
    auth,
    error,
  };
};
